import { render } from "./NotificationDisplayManager.vue?vue&type=template&id=35444744"
import script from "./NotificationDisplayManager.vue?vue&type=script&lang=js"
export * from "./NotificationDisplayManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__